import * as yup from 'yup'

export const createAffiliateSchema = yup.object({
    referrer_name: yup.string().required('Referrer name is required'),
    referrer_email: yup
        .string()
        .email('Invalid email format')
        .required('Email is required'),
    referrer_phone: yup.string(),
    referrer_company: yup.string(),
    customer_id: yup.number().nullable(),
    referral_code: yup.string(),
    tier: yup.string(),
    // Optional: blank means "let the API pick its default". yup casts an empty input to NaN,
    // so map that back to undefined instead of failing validation.
    commission_percent: yup
        .number()
        .transform((value) => (Number.isNaN(value) ? undefined : value))
        .min(0)
        .max(100),
    payout_threshold: yup.number().min(0),
})
